import {StateObservable} from 'redux-observable'
import {Selector} from 'reselect'
import {Observable} from 'rxjs'
import {filter, map, pairwise} from 'rxjs/operators'

export function filterAttrChange<T>(state$: StateObservable<any>, modelSelector: Selector<any, any>, ...attributes: string[]) {
	return <T>(obs$: Observable<T>) => obs$.pipe(
		map((x) => {
			const model = modelSelector(state$.value)
			if (!model) return attributes.map(() => undefined)
			return [...attributes.map(attribute => model[attribute]), x]
		}),
		pairwise(),
		filter(([a, b]) => !attributes.every((attr, i) => a[i] == b[i])),
		map(([a, b]) => b[attributes.length] as T),
	)
}